import React, { useLayoutEffect, useEffect, useRef, Suspense } from "react"
import { Box, Skeleton } from "@mui/material"
import { observer } from "mobx-react"
import { useForm, FormProvider } from "react-hook-form"
import { Header, ExtraHeader, LeadSection, CardSection, TalkToExpert, Description, WhyInvest, WhatIs, SavingPlans, Disclaimers } from "./Components"

import AppStore from "./Configs/Stores/AppStore"
import FormStore from "./Configs/Stores/FormStore"
import { HideLandingLoader } from "./Components/Common/CommonFunctions"
import { DataLayerFn, ipAPI } from "./Configs/API"

const SkeletonStyle = {
  margin: "auto",
  maxWidth: "1100px"
}

const MobileSkeletonStyle = {
  margin: "auto",
  maxWidth: "330px"
}

const SkeletonStyleItem = {
  height: "30px",
  margin: "3px 0px"
}

const MobileSkeletonStyleItem = {
  height: "15px",
  margin: "2px 0px"
}

const SkeletonLoader = observer((props: any) => {
  const isDesktop = AppStore.device === 1
  return (
    <Box ref={props.SectionRef} sx={isDesktop ? SkeletonStyle : MobileSkeletonStyle}>
      <Skeleton sx={isDesktop ? { ...SkeletonStyleItem, width: "50%" } : { ...MobileSkeletonStyleItem, width: "50%" }} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
      <Skeleton sx={isDesktop ? SkeletonStyleItem : MobileSkeletonStyleItem} />
    </Box>
  )
})

const App = observer(() => {
  const DEFAULTS = {
    planType: FormStore.calc_planType,
    gender: FormStore.calc_gender,
    dob: FormStore.calc_dob,
    mobile: FormStore.calc_mobile,
    email: FormStore.calc_email,
    ndncCB: FormStore.calc_ndncCB
  }

  const HookForm = useForm({
    defaultValues: DEFAULTS,
    mode: "onChange"
  })

  useLayoutEffect(() => {
    DataLayerFn("Landed||Calculator-Landing page", FormStore, "", "", "", "")
    const handleResize = () => {
      const width = window.innerWidth
      AppStore.setWindowWidth(width)
      if (width < 1020.5) {
        AppStore.setDevice(0)
      } else {
        AppStore.setDevice(1)
      }
      if (!AppStore.isDepTesting) {
        console.log = () => {}
        console.info = () => {}
      }
      console.log(`Device=${AppStore.device === 0 ? "Mobile" : "PC"}, State=${AppStore.device}, Width=${width}}`)
    }

    handleResize()
    window.addEventListener("resize", handleResize, { passive: true })
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => { 
    if (AppStore.appLoaded) {
      var EmptyScript = window.scriptsLoaded
      var isResume = AppStore.isResumeJourney
      var isStepTrue = new URL(window.location.href).searchParams.get("Step") === "true"

      if (!EmptyScript) {
        const collectIp = async () => {
          const ip = await ipAPI()
          // const ip = { origin: "abc" }
          // console.info("IP :", ip)
          AppStore.setIpAddress(ip["origin"])
          window.ipAddress = ip["origin"]
          localStorage.recent_product = "TaxFreeProp_dynamic"
        }
        if (!isStepTrue) {
          setTimeout(HideLandingLoader, isResume ? 2500 : 1000)
        }
        collectIp()

        window.scriptsLoaded = true
      }
    }
  }, [AppStore.appLoaded])

  return (
    <>
      <ExtraHeader />
      <Header />
      <LeadSection />
      <Description />
      <CardSection />
      <WhyInvest />
      <WhatIs />
      <FormProvider {...HookForm}>
        <SavingPlans />
      </FormProvider>
      <Disclaimers place={"main"} />
      <TalkToExpert />
    </>
  )
})
export default App
